webpackJsonp([1],{

/***/ 78:
/***/ (function(module, exports) {

module.exports = {
	"interface": {
		"name": "Random Anime Chart",
		"reroll": "Reroll",
		"footer": "Based on { originalWebsiteAnchor } | check the { sourceCodeAnchor }",
		"originalWebsiteAnchor": {
			"text": "animedreammachine.com",
			"url": "http://animedreammachine.com"
		},
		"sourceCodeAnchor": {
			"text": "source code at GitHub",
			"url": "https://github.com/qgustavor/random-anime-chart/"
		},
		"episode": "episode",
		"episodes": "episodes",
		"loading": "Loading..."
	},
	"gender": [
		"male",
		"female"
	],
	"firstNames": {
		"male": [
			"Aki",
			"Kenji",
			"Taro",
			"Arata",
			"Daichi",
			"Hideo",
			"Akihiko",
			"Akimasa",
			"Akito",
			"Akio",
			"Akitoshi",
			"Arihiro",
			"Ariaga",
			"Arihiro",
			"Arinaga",
			"Asao",
			"Atsuo",
			"Atsushi",
			"Azuma",
			"Banri",
			"Bunji",
			"Bunta",
			"Choki",
			"Chuuchi",
			"Dai",
			"Daigo",
			"Daizou",
			"Eichi",
			"Eiji",
			"Eisuke",
			"Eizou",
			"Fumio",
			"Fumito",
			"Futoshi",
			"Fuyuki",
			"Gen'ichi",
			"Genta",
			"Gin",
			"Goro",
			"Hakaru",
			"Haruaki",
			"Haruo",
			"Hideaki",
			"Hayata",
			"Hideoyo",
			"Hideyuki",
			"Hiroji",
			"Hiroki",
			"Hiroshi",
			"Hiroya",
			"Hirotoki",
			"Hisao",
			"Hisashi",
			"Ikki",
			"Ippei",
			"Iwao",
			"Isao",
			"Jin",
			"Jiro",
			"Juubei",
			"Junzou",
			"Kagemori",
			"Kaichi",
			"Kaiji",
			"Kaku",
			"Katsuji",
			"Katsuya",
			"Ken",
			"Keiji",
			"Kenki",
			"Kenta",
			"Kihachi",
			"Kinji",
			"Kousuke",
			"Koya",
			"Kyouji",
			"Mahiro",
			"Manabu",
			"Masahide",
			"Masao",
			"Morio",
			"Naoki",
			"Naoto",
			"Nobuo",
			"Noriaki",
			"Norio",
			"Okimoto",
			"Osamu",
			"Otohiko",
			"Raizo",
			"Reiichi",
			"Ryouhei",
			"Ryu",
			"Ryuuta",
			"Saburou",
			"Saiichi",
			"Seigo",
			"Seiji",
			"Shigeki",
			"Shinta",
			"Shouta",
			"Shinji",
			"Shuuhei",
			"Tadafumi",
			"Tadami",
			"Tadao",
			"Taizou",
			"Takamori",
			"Takaki",
			"Takaya",
			"Takehiro",
			"Tetsuo",
			"Tomohide",
			"Tomino",
			"Umanosuke",
			"Umeji",
			"Wataru",
			"Yahiko",
			"Yashiro"
		],
		"female": [
			"Nana",
			"Ai",
			"Aika",
			"Aiko",
			"Aimi",
			"Aina",
			"Airi",
			"Akane",
			"Akari",
			"Akemi",
			"Aki",
			"Akie",
			"Akiko",
			"Amane",
			"Ami",
			"Anzu",
			"Aoi",
			"Asako",
			"Asami",
			"Asuka",
			"Asumi",
			"Asuna",
			"Atsuko",
			"Atsumi",
			"Aya",
			"Ayaka",
			"Ayako",
			"Ayame",
			"Ayami",
			"Ayana",
			"Chie",
			"Chieko",
			"Chiemo",
			"Chiharu",
			"Chiho",
			"Chika",
			"Chinami",
			"Chitose",
			"Chiyo",
			"Chiyako",
			"Chizuru",
			"Eiko",
			"Eimi",
			"Emi",
			"Emiko",
			"Eri",
			"Erika",
			"Etsuko",
			"Fujiko",
			"Fukumi",
			"Fumi",
			"Fumie",
			"Fumika",
			"Fumiko",
			"Fusako",
			"Fuyuko",
			"Fuyumi",
			"Hana",
			"Hanae",
			"Hanko",
			"Harue",
			"Haruna",
			"Haruko",
			"Hideko",
			"Hidemi",
			"Hiroe",
			"Hisae",
			"Hisayo",
			"Hitomi",
			"Ichiko",
			"Ikue",
			"Ikumi",
			"Itsumi",
			"Jitsuko",
			"Junko",
			"Kaguya",
			"Kana",
			"Kanako",
			"Kazue",
			"Kikue",
			"Koharu",
			"Kotomi",
			"Kotori",
			"Kumiko",
			"Kurenai",
			"Kyoko",
			"Maaya",
			"Maaya",
			"Machi",
			"Machiko",
			"Madoka",
			"Maho",
			"Maiko",
			"Mami",
			"Mana",
			"Manaka",
			"Mao",
			"Manami",
			"Mari",
			"Masae",
			"Masako",
			"Mayu",
			"Mayumi",
			"Mei",
			"Michiko",
			"Mie",
			"Miki",
			"Miku",
			"Mikuru",
			"Minako",
			"Minami",
			"Miu",
			"Miyabi",
			"Momo",
			"Momoe",
			"Nagako",
			"Nami",
			"Nanase",
			"Nao",
			"Narumi",
			"Natsume",
			"Nozomi",
			"Otoha",
			"Otome",
			"Ran",
			"Reika",
			"Rie",
			"Riho",
			"Rika",
			"Rumiko",
			"Ruri",
			"Ruriko",
			"Sachika",
			"Saeko",
			"Sakura",
			"Sanae",
			"Saori",
			"Satoko",
			"Saya",
			"Sayako",
			"Sayuri",
			"Seiko",
			"Shinako",
			"Shino",
			"Shizue",
			"Shizuko",
			"Suzuka",
			"Taeko",
			"Tamao",
			"Teiko",
			"Terumi",
			"Tomiko",
			"Toshiko",
			"Tsukiko",
			"Tsuru",
			"Umeko",
			"Wakako",
			"Yaeko",
			"You",
			"Yukari",
			"Yui",
			"Yumeko",
			"Yuri",
			"Yurie",
			"Yurina"
		]
	},
	"lastName": [
		"Yamada",
		"Daiki",
		"Hanamaru",
		"Abe",
		"Adachi",
		"Akagi",
		"Akamine",
		"Aki",
		"Akiyama",
		"Amano",
		"Amaya",
		"Ando",
		"Anno",
		"Anzai",
		"Aoki",
		"Aoyama",
		"Arai",
		"Araki",
		"Arakawa",
		"Arata",
		"Araya",
		"Arima",
		"Arita",
		"Asa",
		"Asai",
		"Asano",
		"Asato",
		"Ashikaga",
		"Azuma"
	],
	"occupation": [
		"a highschooler",
		"a soldier",
		"a wizard",
		"a witch",
		"a hunter",
		"a mangaka",
		"a NEET",
		"a captain",
		"a maid",
		"a butler",
		"a samurai",
		"a warrior",
		"a teacher",
		"an atheist",
		"a teacher",
		"a class president",
		"a politician",
		"a salaryman",
		"a gambler",
		"an yakuza",
		"a servant",
		"a scholar",
		"a royal",
		"a pilot",
		"a superhero",
		"a hero",
		"a general",
		"a shrine maiden",
		"a magical girl",
		"an alchemist",
		"a blacksmith",
		"a writer",
		"an editor",
		"a singer",
		"an idol",
		"a raider",
		"a doctor",
		"a surgeon",
		"a mercenary",
		"a lawyer",
		"a trader",
		"a traitor",
		"a priest",
		"a monk",
		"a butcher",
		"a princess",
		"a sniper",
		"a technician",
		"an engineer",
		"a dancer",
		"a runner",
		"a nurse",
		"a cashier",
		"a clerk",
		"a waiter",
		"an assistant",
		"a manager",
		"an accountant",
		"an auditor",
		"a security guard",
		"a receptionist",
		"a construction worker",
		"a carpenter",
		"a police officer",
		"a model",
		"a teller",
		"a cook",
		"an electrician",
		"a bartender",
		"a bus driver",
		"a jailer",
		"a developer",
		"a machinist",
		"a hairstylist",
		"a firefighter"
	],
	"occupationPlural": [
		"highschoolers",
		"soldiers",
		"wizards",
		"witches",
		"hunters",
		"mangaka",
		"NEETs",
		"captains",
		"maids",
		"butlers",
		"samurais",
		"warriors",
		"teachers",
		"atheists",
		"teachers",
		"class presidents",
		"politicians",
		"salarymans",
		"gamblers",
		"yakuza",
		"servants",
		"scholars",
		"royals",
		"pilots",
		"superheroes",
		"heroes",
		"generals",
		"shrine maidens",
		"magical girls",
		"alchemists",
		"blacksmiths",
		"writers",
		"editors",
		"singers",
		"idols",
		"raiders",
		"doctors",
		"surgeons",
		"mercenaries",
		"lawyers",
		"traders",
		"traitors",
		"priests",
		"monks",
		"butchers",
		"princesses",
		"snipers",
		"technicans",
		"engineers",
		"dancers",
		"runners",
		"nurses",
		"cashiers",
		"clerks",
		"waiters",
		"assisstants",
		"managers",
		"accountants",
		"auditors",
		"security guards",
		"receptionists",
		"construction workers",
		"carpenters",
		"police officers",
		"models",
		"tellers",
		"cooks",
		"electrians",
		"bartenders",
		"bus drivers",
		"jailers",
		"developers",
		"machinists",
		"hairstylists",
		"firefighters"
	],
	"race": [
		"a human",
		"an elf",
		"an orc",
		"a centaur",
		"a snake",
		"a crab",
		"a god",
		"an angel",
		"a devil",
		"a demon",
		"a goblin",
		"a halfling",
		"a bat",
		"a vampire",
		"a robot",
		"a satyr",
		"a homunculus",
		"a cyborg",
		"a clone",
		"a cat",
		"a monkey",
		"a living weapon",
		"a rabbit",
		"a dog",
		"a fox",
		"a wolf",
		"a bird",
		"an eagle",
		"a phoenix",
		"a zombie",
		"an unicorn",
		"a horse",
		"a pony",
		"a spider",
		"a mermaid",
		"an youkai",
		"a spirit",
		"a ghost",
		"a mecha",
		"a monster",
		"a ghoul"
	],
	"racePlural": [
		"humans",
		"elves",
		"orcs",
		"centaurs",
		"snakes",
		"crabs",
		"gods",
		"angels",
		"devils",
		"demons",
		"goblins",
		"halflings",
		"bats",
		"vampires",
		"robots",
		"satyrs",
		"homunculi",
		"cyborgs",
		"clones",
		"cats",
		"monkeys",
		"living weapons",
		"rabbits",
		"dogs",
		"foxes",
		"wolves",
		"birds",
		"eagles",
		"phoenixes",
		"zombies",
		"unicorns",
		"horses",
		"ponies",
		"spiders",
		"mermaids",
		"youkais",
		"spirits",
		"ghosts",
		"mechas",
		"monsters",
		"ghouls"
	],
	"relation": [
		"a rival",
		"a childhood friend",
		"a sibling",
		"a mother",
		"a father",
		"a brother",
		"a parent",
		"a boss",
		"a teacher",
		"a master",
		"a cousin",
		"a servant",
		"a slave",
		"a butler",
		"a sister",
		"an aunt",
		"an uncle",
		"a grand parent",
		"a classmate",
		"a colleague",
		"a fan"
	],
	"objectivePronoun": [
		"his",
		"her"
	],
	"object": [
		"a staff",
		"a sword",
		"a book",
		"a wall",
		"a mansion",
		"a house",
		"a pendant",
		"a crown",
		"a hat",
		"a spear",
		"a dick",
		"a hand",
		"a bottle",
		"a desk",
		"a pen",
		"an earphones",
		"a mobile",
		"a laser",
		"a car",
		"a bike",
		"a smoke",
		"a shadow",
		"a tattoo",
		"a bow",
		"a veil",
		"a shirt",
		"a microphone",
		"a bible",
		"a television",
		"a kimono",
		"a lamp",
		"a clock",
		"a gear",
		"a machine",
		"an axe",
		"a bag",
		"a meat",
		"a flesh",
		"a dice",
		"a dagger",
		"a gun",
		"a rifle",
		"a cannon",
		"a ship",
		"a blood",
		"a shadow",
		"a cord",
		"a rope",
		"a pen",
		"an arkebuse",
		"a horse",
		"a letter",
		"a paper",
		"a tissue",
		"a sheet",
		"a shield",
		"a guitar",
		"a bass",
		"a club",
		"a pelt",
		"a needle",
		"a glasses",
		"a fire",
		"a glass",
		"a permission",
		"a dream",
		"an air",
		"a plant",
		"a rose",
		"a gem",
		"a magic",
		"a katana",
		"a crossbow",
		"a cross",
		"a furnace",
		"a hammer",
		"a rubber",
		"a stone",
		"a monolith",
		"a beam",
		"a tower",
		"a hill",
		"an iron",
		"a scissor",
		"a tear",
		"a door",
		"a bomb"
	],
	"verbToInfinitive": [
		"find",
		"destroy",
		"defeat",
		"save",
		"cook",
		"kill",
		"confess",
		"marry",
		"duel",
		"beat",
		"stock",
		"knock",
		"fight",
		"learn",
		"teach",
		"farm",
		"skate",
		"run",
		"pray",
		"prey on",
		"spray",
		"hunt",
		"dress",
		"bless",
		"dance",
		"herd",
		"govern",
		"burn",
		"bike",
		"salvage",
		"train",
		"sleep with",
		"bath",
		"calculate",
		"love"
	],
	"verbPresentParticiple": [
		"finding",
		"destroying",
		"defeating",
		"saving",
		"cooking",
		"killing",
		"confessing to",
		"marrying",
		"dueling",
		"beating",
		"stocking",
		"knocking",
		"fighting",
		"learning",
		"teaching",
		"farming",
		"skating",
		"running",
		"praying",
		"preying",
		"spraying",
		"hunting",
		"dressing",
		"blessing",
		"dancing",
		"herding",
		"governing",
		"burning",
		"biking",
		"salvaging",
		"training",
		"sleeping",
		"bathing",
		"calculating",
		"loving"
	],
	"verbPastParticiple": [
		"found",
		"destroyed",
		"defeated",
		"saved",
		"ran to",
		"cooked",
		"killed",
		"confessed to"
	],
	"adjective": [
		"a holy",
		"a bored",
		"a burning",
		"an ultimate",
		"an indestructible",
		"a pathetic",
		"an ordinary",
		"a lost",
		"an unholy",
		"a dangerous",
		"an infinite",
		"a sharp",
		"an incredible",
		"a sad",
		"a historical",
		"a humanoid",
		"a broken",
		"a savage",
		"a vicious",
		"a strong",
		"a stable",
		"a weak",
		"a wobbly",
		"an intelligent",
		"a friendly",
		"an aggressive",
		"a mean",
		"an impressive",
		"a good",
		"a precious",
		"an angry",
		"a happy",
		"a cheerful",
		"a salty",
		"a bothered",
		"an experienced",
		"an unknown",
		"a strict",
		"an ignorant",
		"a demeaning",
		"a passive",
		"an incredible",
		"an amazing",
		"a zealous",
		"an unnerving",
		"a baffled",
		"a wicked",
		"a rich",
		"an excellent",
		"an old",
		"a young",
		"a mysterious",
		"a bewildered",
		"an active",
		"an absolute",
		"a normal",
		"an adorable",
		"a cute",
		"an acclaimed",
		"an acrobatic",
		"an adept",
		"an admirable",
		"an admired",
		"an adolescent",
		"an afraid",
		"an aged",
		"an ambitious",
		"a wooden",
		"an anxious",
		"an angelic",
		"an apprehensive",
		"an attentive",
		"an ashamed",
		"an astonishing",
		"an awful",
		"an awkward",
		"a bad",
		"a beautiful",
		"a ravenous",
		"an infected",
		"a beloved",
		"a bitter",
		"a bland",
		"a bleak",
		"a bold",
		"a boring",
		"a brave",
		"a bubbly",
		"a calm",
		"a calculating",
		"a careful",
		"a charming",
		"a cheerful",
		"a clumsy",
		"a clueless",
		"a competent",
		"a composed",
		"a cool",
		"a corrupt",
		"a crafty",
		"a creative",
		"a creepy",
		"a criminal",
		"a cultivated",
		"a dangerous",
		"a dazzling",
		"a dark",
		"a deadly",
		"a dense",
		"a devoted",
		"a dimwitted",
		"a distant",
		"a dreary",
		"a dirty",
		"a dizzy",
		"a doting",
		"a dry",
		"a distant",
		"an eager",
		"an easy-going",
		"an euphoric",
		"an embarrassed",
		"an excellent",
		"an excited",
		"a virgin",
		"a fabulous",
		"a faithful",
		"a fake",
		"a fancy",
		"a familiar",
		"a feisty",
		"a flashy",
		"a focused",
		"a foolish",
		"a frail",
		"a frilly",
		"an evil",
		"a good",
		"a compulsive"
	],
	"adjectiveComparative": [
		"holier",
		"more boring",
		"more burning",
		"more ultimate",
		"more indestructible",
		"more pathetic",
		"more ordinary",
		"more lost",
		"unholier",
		"more dangerous",
		"more infinite",
		"sharper",
		"more incredible",
		"sadder",
		"more historical",
		"humanoider",
		"brokener",
		"more savage",
		"more vicious",
		"stronger",
		"stabler",
		"weaker",
		"wobblier",
		"more intelligent",
		"friendlier",
		"more aggressive",
		"meaner",
		"more impressive",
		"better",
		"more precious",
		"angrier",
		"happier",
		"more cheerful",
		"saltier",
		"more bothered",
		"more experienced",
		"more unknown",
		"stricter",
		"ignoranter",
		"more demeaning",
		"passiver",
		"more incredible",
		"more amazing",
		"more zealous",
		"more unnerving",
		"more baffled",
		"wickeder",
		"richer",
		"more excellent",
		"older",
		"younger",
		"more mysterious",
		"more bewildered",
		"more active",
		"absoluter",
		"more normal",
		"more adorable",
		"cuter",
		"acclaimeder",
		"more acrobatic",
		"adepter",
		"more admirable",
		"mor eadmired",
		"adolescenter",
		"more afraid",
		"more aged",
		"more ambitious",
		"woodener",
		"more anxious",
		"more angelic",
		"apprehensiver",
		"more attentive",
		"more ashamed",
		"more astonishing",
		"more awful",
		"awkwarder",
		"worse",
		"more beautiful",
		"more ravenous",
		"more infected",
		"more beloved",
		"bitterer",
		"blander",
		"bleaker",
		"bolder",
		"more boring",
		"braver",
		"bubblier",
		"calmer",
		"more calculating",
		"more careful",
		"more charming",
		"cheerfuller",
		"clumsier",
		"more clueless",
		"competenter",
		"more composed",
		"cooler",
		"corrupter",
		"craftier",
		"more creative",
		"creepier",
		"more criminal",
		"more cultivated",
		"more dangerous",
		"dazzlinger",
		"darker",
		"deadlier",
		"denser",
		"more devoted",
		"more dimwitted",
		"more distant",
		"drearier",
		"dirtier",
		"dizzier",
		"more doting",
		"drier",
		"more eager",
		"more easy-going",
		"more euphoric",
		"more embarrassed",
		"excellenter",
		"more excited",
		"more virgin",
		"more fabulous",
		"more faithful",
		"faker",
		"fancier",
		"more familiar",
		"feistier",
		"flashier",
		"more focused",
		"foolisher",
		"frailer",
		"frillier",
		"more evil",
		"more compulsive"
	],
	"adjectiveValue": [
		"best",
		"worst"
	],
	"assessment": [
		"poor",
		"good",
		"bad",
		"great",
		"mediocre",
		"ordinary",
		"horrible",
		"amazing",
		"incredible",
		"large",
		"small"
	],
	"determiner": [
		"last",
		"first",
		"second",
		"third",
		"fourth",
		"fifth",
		"sixth",
		"seventh",
		"eighth",
		"ninth",
		"tenth",
		"eleventh",
		"twelfth",
		"thirteenth"
	],
	"ownership": [
		"a master",
		"a wielder",
		"a creator",
		"an user",
		"a disciple",
		"an owner",
		"an exchanger",
		"a builder",
		"a lord",
		"a host",
		"a diregent"
	],
	"characterTrope": [
		"a tsundere",
		"a kuudere",
		"a yandere",
		"a tomboy",
		"a heroine",
		"a villain"
	],
	"group": [
		"a yakuza",
		"a gang",
		"a student council",
		"a mercenaries",
		"a cabal",
		"a cult",
		"a secret society",
		"a guerillia",
		"a thugs",
		"an organisation"
	],
	"groupSize": [
		"a swarm",
		"a squad",
		"a group",
		"a legion",
		"a mass",
		"a couple",
		"a regiment",
		"a horde",
		"a flock",
		"a storm",
		"a division"
	],
	"color": [
		"black",
		"white",
		"red",
		"green",
		"blue",
		"yellow",
		"orange",
		"grey",
		"silver",
		"gold",
		"teal",
		"pink",
		"beige",
		"brown"
	],
	"bodypart": [
		"a locks",
		"a hair",
		"a hand",
		"an arm",
		"a leg",
		"a finger",
		"a foot",
		"a head",
		"a neck",
		"a back",
		"a belly",
		"a toe",
		"a fingernail",
		"a bottom",
		"an eye",
		"an ear",
		"a nose",
		"a lip",
		"a tongue",
		"a palm",
		"an eyebrow",
		"a heart",
		"a breast",
		"a brain",
		"a spine",
		"a skin"
	],
	"measures": [
		"centimetres",
		"degrees",
		"litres",
		"ampere",
		"kilograms",
		"hertz",
		"frames",
		"newton",
		"lux",
		"lumen",
		"joule",
		"farad",
		"tesla",
		"volt",
		"watt"
	],
	"element": [
		"ice",
		"fire",
		"stone",
		"water",
		"snow"
	],
	"abstractConcept": [
		"love",
		"friendship",
		"revenge",
		"greed",
		"pity",
		"gluttony",
		"wrath",
		"war",
		"conflict",
		"relationship",
		"marriage",
		"duty",
		"loyality",
		"romance"
	],
	"locations": [
		"classroom",
		"quarry",
		"office",
		"floor",
		"room",
		"high school",
		"middle school",
		"kindergarten",
		"building",
		"tent",
		"forest",
		"hill",
		"ballroom",
		"cottage",
		"storefront",
		"mall",
		"market street",
		"manor"
	],
	"locationPlace": [
		"a town",
		"a village",
		"a city",
		"a world",
		"a country",
		"a district",
		"a house",
		"a room",
		"a school",
		"a star",
		"a planet",
		"a state",
		"a prefecture",
		"a province",
		"a dimension",
		"a territory",
		"an empire",
		"a realm",
		"a land"
	],
	"locationNature": [
		"an ocean",
		"a forest",
		"a mountains",
		"a swamp",
		"a desert",
		"a heaven",
		"a hell"
	],
	"occupationLocation": [
		"a school",
		"a work",
		"an university"
	],
	"place": [
		"Tokyo",
		"Osaka",
		"Hiroshima",
		"Kyoto",
		"Kure",
		"Akihabara",
		"Shibuya",
		"Akiba",
		"Yokohama",
		"Naogya",
		"Kobe",
		"Sapporo",
		"Fukuoka",
		"Nara",
		"Sendai",
		"Kitakyushu",
		"Okayama",
		"Hiroshima",
		"Hamamatsu",
		"Kanazawa",
		"Nagasaki",
		"Hakodate",
		"Himeji",
		"Shinjuku",
		"Taitou",
		"Meguro",
		"Kita",
		"Arakawa",
		"Adachi",
		"Ueno",
		"Oumori",
		"Haneda",
		"Minato"
	],
	"period": [
		"Edo",
		"Sengoku",
		"Meiji",
		"Taishou",
		"Shouwa",
		"Heisei"
	],
	"era": [
		"prohibition",
		"sengoku",
		"byzantine",
		"spanish",
		"mesoamerican",
		"ming",
		"dinosaur"
	],
	"weather": [
		"rainy",
		"foggy",
		"sunny",
		"misty",
		"snowy",
		"hot"
	],
	"timespan": [
		"second",
		"minute",
		"hour",
		"day",
		"week",
		"month",
		"year",
		"decade"
	],
	"time": [
		"past",
		"future",
		"present"
	],
	"stateform": [
		"kingdom",
		"empire",
		"republic",
		"theocracy",
		"merchant republic",
		"chiefdom",
		"tribe",
		"dictatorship"
	],
	"catastrophe": [
		"an earthquake",
		"a lightning storm",
		"a storm",
		"a tsunami",
		"a riot",
		"a rebellion",
		"a hack",
		"an eruption",
		"a virus",
		"a civil war",
		"a bombing",
		"a strike",
		"an explosion",
		"a massacre",
		"a famine",
		"a tornado",
		"an eruption",
		"a blizzard",
		"a cyclone",
		"a stampede",
		"an accident",
		"a terror",
		"a comet",
		"a party"
	],
	"season": [
		"summer",
		"spring",
		"fall",
		"winter"
	],
	"timeOfDay": [
		"a dawn",
		"a noon",
		"a sunrise",
		"a twilight",
		"a dusk",
		"a evening",
		"an afternoon",
		"a night"
	],
	"studio": [
		"Studio Teen",
		"Moonrise",
		"NWT",
		"Gaijin",
		"Triggered",
		"GOLDEN LINK.",
		"Z+1 Pictures",
		"Tokyo Animation",
		"Leecher",
		"Goda Boko",
		"triomedea",
		"CALMHOUSE",
		"GoFeets",
		"N.S.Staff",
		"Studio 593",
		"Internet Animation Movie",
		"alientable",
		"Pierro",
		"Studio Joker",
		"16-bit",
		"Shebek",
		"Cat in the hat",
		"CALCIUM",
		"Zombies Base",
		"Light-gray Fox",
		"Eve Production",
		"sensation.",
		"No G",
		"Tunnel",
		"Lemons and Oranges",
		"Studio 1/0.333s"
	],
	"source": [
		"Manga",
		"Light Novel"
	],
	"director": [
		""
	],
	"scriptWriter": [
		""
	],
	"genres": [
		"romance",
		"drama",
		"battle",
		"harem",
		"horror",
		"adventure",
		"school",
		"war",
		"isekai",
		"slice of life",
		"sport",
		"gore",
		"action",
		"supernatural",
		"fantasy",
		"comedy",
		"yaoi",
		"yuri",
		"psychological",
		"historical",
		"mystery",
		"crime",
		"thriller",
		"music",
		"martial arts",
		"sci-fi",
		"space"
	],
	"specialCharacters": [
		[
			"!",
			3
		],
		[
			"*",
			1
		],
		[
			".",
			1
		],
		[
			"?",
			1
		],
		[
			"+",
			1
		],
		[
			"*",
			1
		],
		[
			"#",
			1
		]
	],
	"suffixes": [
		"san",
		"kun",
		"chan",
		"sama",
		"sensei"
	],
	"preposition": [
		"under",
		"over",
		"in",
		"next to",
		"close to",
		"inside"
	],
	"keysWithArticles": [
		"catastrophe",
		"locationNature",
		"locationPlace",
		"bodypart",
		"groupSize",
		"group",
		"characterTrope",
		"ownership",
		"adjective",
		"object",
		"relation",
		"race",
		"occupation",
		"genderName",
		"occupationDeterminer",
		"adjectiveSek",
		"relation",
		"relationSek",
		"relationTert",
		"objectSecond",
		"objectRelation"
	],
	"titleTemplates": [
		"{setting.place} {protagonist.firstName}",
		"{protagonist.firstName}",
		"{setting.place} {protagonist.occupation | capitalize}",
		"{setting.location | capitalize } Crisis",
		"The {protagonist.occupationDeterminer | capitalize} {protagonist.occupation | capitalize}",
		"{protagonist.occupation | capitalize} in another {setting.locationPlace | capitalize}",
		"My {protagonist.occupation | capitalize} Academia",
		"{protagonist.firstName} the {protagonist.adjective | capitalize} {protagonist.occupation | capitalize}",
		"{protagonist.threat}",
		"{protagonist.nickname}",
		"{setting.location | capitalize} of the {protagonist.threat | capitalize}",
		"{protagonist.color | capitalize} {protagonist.occupation | capitalize}",
		"Legend of the {protagonist.adjective | capitalize} {protagonist.occupation | capitalize}s",
		"The {protagonist.objectRelation | capitalize} of {protagonist.occupation | capitalize}",
		"{protagonist.occupation | capitalize} {protagonist.genderName | capitalize}s",
		"{setting.adjective | capitalize} {setting.location | capitalize}",
		"{protagonist.firstName}-{suffixes}",
		"{protagonist.occupation | capitalize}Beats}",
		"{meta.PresentParticiple | capitalize}",
		"{protagonist.occupation | capitalize}",
		"{protagonist.allies | capitalize} versus {protagonist.threat | capitalize}",
		"My {secondaryCharacter.adjectiveSek | capitalize} {secondaryCharacter.relation | capitalize} can't be that {secondaryCharacter.adjective | capitalize}",
		"A Certain {protagonist.adjective | capitalize} {protagonist.occupation | capitalize}",
		"{protagonist.firstName} {preposition} the {setting.location | capitalize}",
		"{meta.adjective | capitalize} {protagonist.object | capitalize}",
		"{protagonist.occupation | capitalize} x {protagonist.occupation | capitalize}",
		"{protagonist.firstName} of the {setting.timeOfDay | capitalize}",
		"{setting.catastropheSpice | capitalize} {setting.catastrophe | capitalize}",
		"{setting.catastropheSpice | capitalize}",
		"{protagonist.firstName} the {protagonist.adjective | capitalize}",
		"{setting.wildcardSubject | capitalize}",
		"{protagonist.firstName} to {secondaryCharacter.firstName}",
		"{protagonist.object | capitalize} {protagonist.genderName | capitalize}",
		"{setting.wildcardSubject | capitalize} in the {protagonist.object | capitalize}",
		"{protagonist.object | capitalize} of the {protagonist.occupation | capitalize}",
		"{protagonist.threatRace | capitalize} and {setting.wildcardSubject | capitalize}",
		"{setting.wildcardSubject | capitalize}-Blooded {protagonist.occupationPlural | capitalize}",
		"{random | 1 | 100} {measures | capitalize} per {setting.timespan | capitalize}",
		"{protagonist.occupation | capitalize} of the {protagonist.threatRace | capitalize}",
		"{protagonist.color | capitalize} {setting.location | capitalize}",
		"The {setting.wildcardSubject | capitalize} of a {protagonist.threatRace | capitalize} {setting.location | capitalize}",
		"{setting.location | capitalize} of {protagonist.threat | capitalize}",
		"{protagonist.firstName} on {protagonist.element | capitalize}",
		"{meta.adjective | capitalize} {protagonist.allies | capitalize}",
		"To Be {protagonist.occupation | capitalize}",
		"{protagonist.adjective | capitalize}-Eyed {protagonist.firstName}",
		"{object | capitalize}/{object | capitalize} {object | capitalize}",
		"{setting.location | capitalize} {setting.timespan | capitalize}s",
		"{protagonist.race | capitalize} {protagonist.occupation | capitalize}",
		"{protagonist.adjective | capitalize} {protagonist.occupation | capitalize}",
		"{protagonist.firstName} Wants to be {protagonist.verbPastParticiple | capitalize}",
		"All you need is {protagonist.verbToInfinitive | capitalize}",
		"{adjectiveComparative | capitalize} Than {setting.wildcardSubject | capitalize}"
	],
	"subtitleTemplates": [
		"The {setting.countryStateform | capitalize} of {protagonist.object | capitalize}",
		"{protagonist.objectAdj | capitalize} {protagonist.object | capitalize}",
		"{object | capitalize}",
		"{protagonist.firstName} of the {object | capitalize}",
		"{protagonist.threatRace | capitalize} {protagonist.occupation | capitalize}",
		"{object | capitalize} {setting.catastrophe}  Dance",
		"{protagonist.verbPresentParticiple | capitalize} with {protagonist.firstName}",
		"{protagonist.occupationPlural | capitalize} of the {setting.timeOfDay | capitalize} {setting.location | capitalize}",
		"Second Season"
	],
	"genderData": {
		"male": {
			"pronoun": "he",
			"objectivePronoun": "his",
			"personalPronoun": "him",
			"youngGenderName": "a boy",
			"adultGenderName": "a man",
			"perfectTense": "he's"
		},
		"female": {
			"pronoun": "she",
			"objectivePronoun": "her",
			"personalPronoun": "her",
			"youngGenderName": "a girl",
			"adultGenderName": "a woman",
			"perfectTense": "she's"
		}
	},
	"goalTemplates": [
		"be the best {protagonist.occupation}",
		"{verbToInfinitive} {protagonist.objectivePronoun} lost {relation}"
	],
	"sentenceFirst": {
		"oneCharacter": [
			"{protagonistName} is a {protagonist.age} year old {protagonist.occupation}",
			"{protagonistName} is the {protagonist.occupationDeterminer} {protagonist.occupation}",
			"The story centers around {protagonistName}, the last {protagonist.occupation}",
			"{protagonistName} lives in the {setting.location} and is {protagonist.assessment} at {protagonist.verbPresentParticiple}",
			"{protagonistName} is the {protagonist.objectRelation} of the {protagonist.objectAdj} {protagonist.object}",
			"{protagonistName} wants to {protagonist.goal} in {setting.place}",
			"{protagonistName} isn't your typical {protagonist.occupation}",
			"{protagonistName} is a seemingly {protagonist.adjective} {protagonist.genderName} living with {protagonist.objectivePronoun} {secondaryCharacter.relation} in a {setting.location}",
			"{protagonistName} inherits {protagonist.object | indefiniteArticle} from {protagonist.objectivePronoun} {secondaryCharacter.relation}",
			"{protagonistName}, {protagonist.occupation | indefiniteArticle}",
			"A heartwarming story about {protagonist.occupation | indefiniteArticle}, who was given {protagonist.object | indefiniteArticle} from {tertiaryCharacter.race | indefiniteArticle}",
			"{protagonistName} is {protagonist.characterTrope | indefiniteArticle} who's not especially {protagonist.assessment} at anything in particular",
			"{protagonistName} possesses the {protagonist.ability} ability, but it is not strong enough to make {protagonist.personalPronoun} particularly important",
			"{protagonistName} is {protagonist.adjective | indefiniteArticle} {protagonist.age} year-old {protagonist.genderName} who lives near the {setting.locationNature} and {protagonist.pronoun} spends much of {protagonist.objectivePronoun} time {protagonist.verbPresentParticiple} as a result",
			"The show's story revolves around {protagonistName}, who carried all of {setting.country}'s hopes on {protagonist.objectivePronoun} shoulders to win at the Grand Prix Finale {protagonist.occupation | capitalize} competition, but suffered a crushing defeat",
			"{protagonistName} is {protagonist.adjective | indefiniteArticle} {protagonist.genderName} with a {protagonist.adjective | indefiniteArticle} {protagonist.bodypart}",
			"{protagonistName} is {protagonist.occupation | indefiniteArticle} who just got robbed by {secondaryCharacter.adjective | indefiniteArticle} {secondaryCharacter.genderName}, but {protagonist.objectivePronoun} luck seems to be looking up, as another {secondaryCharacter.adjective} {secondaryCharacter.genderName} has taken {protagonist.personalPronoun} in",
			"{protagonistName} has a few reasons why she wants to 'reset' {protagonist.objectivePronoun} image & life as a new {protagonist.occupation}",
			"{protagonistName}, {protagonist.adjective | indefiniteArticle} {protagonist.age}-old {protagonist.occupation}, hasn't gotten along with {protagonist.objectivePronoun} younger {secondaryCharacter.relation}, {secondaryCharacter.firstName}, in {setting.timespan}s"
		],
		"twoCharacters": [
			"Having lost {protagonist.objectivePronoun} {tertiaryCharacter.relation}, {protagonist.occupation} {protagonistName} is doing {protagonist.objectivePronoun} best to raise {protagonist.objectivePronoun} young {secondaryCharacter.relation} {secondaryCharacter.firstName} as a single {protagonist.relationSek}",
			"On a {setting.timeOfDay | indefiniteArticle} lit by a crimson full moon, an ordinary {protagonist.occupation} named {protagonistName} meets a self-proclaimed {secondaryCharacter.occupation} named {secondaryCharacter.firstName} at a festival"
		],
		"setting": [
			"A story set in {setting.place}",
			"'{title.primary}' takes place in a {setting.location}",
			"The anime focuses on {protagonist.object | indefiniteArticle} club in a certain {setting.location}, and its members",
			"The {setting.country} {setting.countryStateform} is at war with the neighboring {setting.countrySekStateform} of {setting.countrySek}",
			"The 'classic {protagonist.group} {setting.genreMain}'-story takes place during the {setting.era | capitalize} era",
			"The {setting.genreMain} story is set in {setting.place}, which is haunted by {protagonist.threatAdjective} '{protagonist.threatRace}' who are devouring {protagonist.alliesRace}",
			"On a {setting.season} day… a massive {setting.catastrophe} suddenly strikes {setting.place}"
		]
	},
	"sentenceMid": {
		"oneCharacter": [
			"Then, one day, {protagonist.genderPerfectTense} attacked by {protagonist.threatGroupSize | indefiniteArticle} of {protagonist.threat} and saved by a mysterious {tertiaryCharacter.genderName}",
			"{protagonist.objectivePronoun | capitalize} {secondaryCharacter.relation}, {secondaryCharacter.firstName}, is also {protagonist.occupation | indefiniteArticle}",
			"The difference is {protagonist.genderPerfectTense} {protagonist.race | indefiniteArticle}; but {protagonist.genderPerfectTense} not alone",
			"After one {setting.weather} {setting.timespan}, {protagonist.pronoun} doesn't turn up at {setting.occupationLocation}, having been admitted into a hospital in a distant {setting.locationPlace}",
			"{protagonist.pronoun | capitalize} meets {tertiaryCharacter.genderName | indefiniteArticle} named {tertiaryCharacter.firstName} who dislikes disruptions in {tertiaryCharacter.objectivePronoun} everyday life",
			"{protagonist.objectivePronoun | capitalize} life changes after {protagonist.pronoun} met {secondaryCharacter.firstName} {secondaryCharacter.lastName} of a Research Institute, who offered {protagonist.personalPronoun} a drug that can change {protagonist.objectivePronoun} appearance to {random | 2 | 100}-years-old and to become a subject in an experiment for one year",
			"{protagonist.firstName} believes in the folklore that says 'long ago, every human was able to see the {protagonist.threatRace}' and dreams of unraveling the ancient mystery to make the {setting.locationPlace} a place where people and {protagonist.threatRace} can live together in peace",
			"{protagonist.genderPerfectTense | capitalize} pretty bad at {protagonist.verbPresentParticiple}, but chance brings {protagonist.objectivePronoun} little family and one of {protagonist.objectivePronoun} {secondaryCharacter.relation}, {secondaryCharacter.firstName}, together for homemade adventures",
			"No one would have expected that this {protagonist.age} year old young {protagonist.genderName} would eventually become a {protagonist.occupation} called a great {protagonist.relationSek} by others",
			"But, that was not the only thing in {protagonist.objectivePronoun} life that {protagonist.firstName} was feeling frustrated about…",
			"In {protagonist.objectivePronoun} dying moments, {protagonist.firstName} is transported to a {setting.locationPlace} of magic with other famous {protagonist.occupationPlural} throughout history",
			"Through strange circumstances {protagonist.pronoun} finds {protagonist.personalPronoun}self drawn into the {setting.locationPlace} of survival games by a host, {tertiaryCharacter.firstName} {tertiaryCharacter.lastName}",
			"Behind this, {protagonist.pronoun} has feelings of wanting to surpass {secondaryCharacter.firstName}, who is respected as {protagonist.occupation | indefiniteArticle}",
			"Only a {protagonist.adjective} {protagonist.occupation} can have the privilege to contract with a spirit"
		],
		"twoCharacters": [
			"However, through mysterious circumstances, the girls find themselves the final survivors in {protagonist.threatRace | indefiniteArticle} attack, and continue to live at the {setting.occupationLocation}"
		],
		"setting": [
			"In the {setting.country} {setting.countryStateform}, the {protagonist.adjective}, woman-admiring {protagonist.firstName} {protagonist.lastName} hates {protagonist.abstractConcept}, but due to certain circumstances, {protagonist.pronoun} grudgingly takes the high grade {protagonist.occupation} exam",
			"{random | 2 | 10000} years later, {protagonist.occupation | indefiniteArticle} named {protagonist.firstName} {protagonist.lastName} accidently uncovers the {protagonist.threatRace} in a hidden {setting.location} under {protagonist.objectivePronoun} family’s {setting.locationPlace}",
			"{protagonist.adjective | capitalize} appearance, {protagonist.adjective} intelligence, {protagonist.adjective} in arts and sports... just {protagonist.adjective}"
		],
		"structures": [
			"The fate of the world is threatened as an army of {protagonist.threatAdjective} {protagonist.threat} are sent from the future to alter the course of history",
			"{protagonist.firstName} inherits memories and interests from {protagonist.objectivePronoun} previous life, and aims to be a {protagonist.objectRelation} of a {protagonist.objectSecond | capitalize}{protagonist.object}, a large {protagonist.objectAdj} weapon that really exists in {protagonist.objectivePronoun} {setting.locationPlace}",
			"Egged on by {protagonist.objectivePronoun} friends, {protagonist.firstName} goes on {protagonist.objectivePronoun} knees and confesses {protagonist.objectivePronoun} love to {protagonist.objectivePronoun} {secondaryCharacter.relation} named {secondaryCharacter.firstName}",
			"The {setting.genre} {protagonist.characterTrope} trend had started with a small festival in a certain {setting.locationPlace}",
			"Those that dare to explore the depths are known as {protagonist.threat}",
			"The sudden disaster that becomes known as the {setting.wildcard | capitalize} {setting.catastropheSpice | capitalize} {setting.catastrophe | capitalize} kills {random | 2 | 10000} people and injures {random | 2 | 10000} more",
			"This story follows a {setting.locationPlace} {protagonist.occupation} who has a great interest in {protagonist.threatRace} and {protagonist.objectivePronoun} interaction with the various {protagonist.threatRace} in {protagonist.objectivePronoun} {setting.occupationLocation}, each with their own {meta.adjective} problems",
			"{protagonist.firstName} also often has business trips from the capital to the other {setting.locationPlace}'s to check on the situation and {occupationPlural} there",
			"Until the day when {tertiaryCharacter.occupation | indefiniteArticle} they know requests their help in taking down a new {protagonist.threatGroup} muscling in on the territory of a top {protagonist.threatGroup}",
			"{protagonist.firstName} enrolls in the {setting.locationPlace}'s leading elite public morals {setting.occupationLocation} and is soon invited into the Anti-{protagonist.occupation} {protagonist.threatGroup} by its founder, {secondaryCharacter.firstName} {secondaryCharacter.lastName}",
			"So who wouldn't take the chance to change the {setting.time} if given the opportunity",
			"{protagonist.firstName} rescues a homeless {tertiaryCharacter.genderName} on the street one day from some {protagonist.threatGroup}, and the {tertiaryCharacter.genderName} gives {protagonist.firstName} an object that imprints {protagonist.object | indefiniteArticle} on {protagonist.objectivePronoun} {protagonist.bodypart}",
			"However, one day, a large {protagonist.threadRaceSingular} attacks {setting.country}",
			"One day in {setting.season}, the cute but weird {tertiaryCharacter.genderName} {tertiaryCharacter.firstName} {tertiaryCharacter.lastName}, from the famous {protagonist.object} company, comes to pay a visit",
			"{protagonist.firstName} and {secondaryCharacter.firstName}, the heroes of the story, hold the keys to open the {protagonist.object}",
			"{tertiaryCharacter.lastName}, who is a veteran {protagonist.occupation} for the {protagonist.occupation} department, is looking for a successor now that {tertiaryCharacter.genderPerfectTense} approaching retirement age",
			"{protagonist.firstName} {protagonist.lastName} uses {protagonist.objectivePronoun} power without others knowing, and lives a fairly normal, average school life",
			"{protagonist.firstName} refuses, chops off {protagonist.objectivePronoun} lovely {protagonist.bodypart}, and runs away to the neighboring {setting.countryStateform} of {setting.country}",
			"But a new conflict approached unseen",
			"{tertiaryCharacter.firstName}, a {protagonist.occupation} from an alternate-dimension {protagonist.occupation} {setting.locationPlace}, challenged the {protagonist.occupation} king for the throne and lost",
			"{secondaryCharacter.firstName} and {protagonist.firstName} are almost constantly under attack and must learn to live their lives, avoiding being consumed by {protagonist.abstractConcept}"
		]
	},
	"sentenceLast": [
		"Can {protagonistName} save the {setting.locationPlace}?",
		"The adventure begins!",
		"Based on the popular {meta.source}.",
		"In full CGI.",
		"Based on myths from {setting.country}.",
		"Maybe... there is even a little hope for some {protagonist.abstractConcept} in {protagonist.objectivePronoun} future."
	]
};

/***/ })

});


// WEBPACK FOOTER //
// static/js/1.1dd4dcb247c0214f9dba.js